import type { HelpArticle } from '../../../components/help/types';

export const configurationArticles: HelpArticle[] = [
  {
    id: 'platform-config-overview',
    title: 'Platform Configuration',
    summary: 'Configure platform-wide settings and defaults.',
    category: 'configuration',
    order: 1,
    keywords: ['configuration', 'settings', 'platform', 'system', 'defaults'],
    content: `
# Platform Configuration

Configure settings that apply across all MDAs.

## Configuration Areas

### Document Types
Define available document types:
- Letters, Memos, Reports
- Custom types for specific needs
- Metadata fields per type
- Default settings

### Classification Levels
Security classification settings:
- Level names and colors
- Access restrictions
- Handling procedures
- Retention rules

### Retention Policies
Document lifecycle management:
- Retention periods by type
- Archival rules
- Disposal procedures
- Legal holds

### Security Settings
Platform security configuration:
- Password policies
- Session timeouts
- Two-factor authentication
- IP restrictions

### Integrations
External system connections:
- Email servers
- SMS gateways
- Backup services
- Authentication providers

## Applying Changes

Changes may affect:
- All MDAs immediately
- Only new MDAs
- Existing MDAs with override

## Best Practices

- Test changes in a sandbox first
- Communicate changes to MDA admins
- Document all configuration changes
- Keep security settings strict
    `,
  },
];
